import React from "react";
import { AUTH_PREFIX_PATH } from "configs/AppConfig";

export const publicRoutes = [
  {
    key: "login",
    path: `${AUTH_PREFIX_PATH}/login`,
    component: React.lazy(() =>
      import("views/auth-views/authentication/login")
    ),
  },
  // {
  //   key: "not-found-public",
  //   path: "/404",
  //   component: React.lazy(() => import("views/auth-views/errors/error-page-1")),
  // },
];

export const protectedRoutes = [
  {
    key: "dashboard",
    path: `/dashboard`,
    component: React.lazy(() => import("views/dashboard")),
  },
  {
    key: "visitor-log",
    path: `/visitor-log`,
    component: React.lazy(() => import("views/visitor-log")),
  },
  {
    key: "user",
    path: `/user`,
    component: React.lazy(() => import("views/user")),
  },
  {
    key: "report",
    path: `/report`,
    component: React.lazy(() => import("views/report")),
  },
  {
    key: "qrcode",
    path: `/qrcode`,
    component: React.lazy(() => import("views/qr-code")),
  },
  {
    key: "not-found",
    path: "/not-found",
    component: React.lazy(() => import("views/auth-views/errors/error-page-2")),
  },
];
